/*
  Recept-artikel interactie (template article.recept):
  - personen-stepper die hoeveelheden in de ingredientenlijst schaalt
  - afvinkbare ingredienten
  - knop die alle gelinkte producten uit de (aangevinkte) ingredienten
    in een keer aan de winkelwagen toevoegt
  - stappen in de bereidingswijze voorzien van een nummer-cirkel
  Alles is progressive enhancement: zonder JS blijft de pagina gewoon leesbaar.
*/
(function () {
  'use strict';

  // build: ingredient-body-wrap + fix 2026-09-05 (hoeveelheid in productlink, verpakking uit optienaam)
  var QTY_RE = /\d+(?:[.,]\d+)?/g;

  function hasProductLink(li) {
    return !!li.querySelector('a[href*="/products/"]');
  }

  // Leest de (geschaalde) hoeveelheid van een ingredientregel:
  // het eerste getal buiten de productlink plus de eenheid erachter.
  function neededAmount(li) {
    var sp = li.querySelector('.recipe-qty');
    if (!sp) return {};
    var val = parseFloat(sp.textContent.replace(',', '.'));
    if (isNaN(val)) return {};
    var after = '';
    var n = sp.nextSibling;
    while (n && after.replace(/\s/g, '').length < 8) {
      after += n.textContent || '';
      n = n.nextSibling;
    }
    var stuks = after.match(/^\s*(?:stuks|stukken|stuk)\b/i);
    if (stuks && val === Math.round(val) && val >= 1 && val <= 50) {
      return { count: val, hint: pieceSizeHint(li) };
    }
    var m = after.match(/^\s*(kg|kilo|gram|gr|g|ml|cl|liter|l)\b/i);
    if (!m) {
      // Los heel aantal direct voor de productlink ("2 zeebaarsfilets") = stuks
      var sib = sp.nextSibling;
      while (sib && sib.nodeType === 3 && !sib.nodeValue.trim()) sib = sib.nextSibling;
      if (sib && sib.nodeType === 1 && sib.tagName === 'A' && val === Math.round(val) && val >= 1 && val <= 50) {
        return { count: val, hint: pieceSizeHint(li) };
      }
      return {};
    }
    var u = m[1].toLowerCase();
    if (u === 'kg' || u === 'kilo') return { g: val * 1000 };
    if (u === 'g' || u === 'gr' || u === 'gram') return { g: val };
    if (u === 'l' || u === 'liter') return { ml: val * 1000 };
    if (u === 'cl') return { ml: val * 10 };
    return { ml: val };
  }

  // Maat per stuk uit de regeltekst, bijv. "a 225 gram", "van 300 gram", "(ca. 1 kg)".
  function pieceSizeHint(li) {
    var m = li.textContent.match(/(?:\b(?:a|à|van)\s+|\(?\s*ca\.?\s*)(\d+(?:[.,]\d+)?)\s*(kg|kilo|gram|gr|g)\b/i);
    if (!m) return null;
    var val = parseFloat(m[1].replace(',', '.'));
    if (/^k/i.test(m[2])) val *= 1000;
    return val;
  }

  // Verpakkingsgrootte uit de variant- of producttitel, bijv. "ca. 160 gram" of "250 ml".
  // Multipacks zoals "10 x 80 gram" tellen als één verpakking van 800 gram.
  function parsePack(text) {
    var mx = (text || '').match(/(\d+)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(kg|kilo|gram|gr|g|ml|cl|liter|l)\b/i);
    if (mx) {
      var per = parseFloat(mx[2].replace(',', '.'));
      var u2 = mx[3].toLowerCase();
      var factor = 1;
      if (u2 === 'kg' || u2 === 'kilo' || u2 === 'l' || u2 === 'liter') factor = 1000;
      else if (u2 === 'cl') factor = 10;
      var kind2 = (u2 === 'ml' || u2 === 'cl' || u2 === 'l' || u2 === 'liter') ? 'ml' : 'g';
      return { kind: kind2, value: parseInt(mx[1], 10) * per * factor };
    }
    var m = (text || '').match(/(\d+(?:[.,]\d+)?)\s*(kg|kilo|gram|gr|g|ml|cl|liter|l)\b/i);
    if (!m) return null;
    var val = parseFloat(m[1].replace(',', '.'));
    var u = m[2].toLowerCase();
    if (u === 'kg' || u === 'kilo') return { kind: 'g', value: val * 1000 };
    if (u === 'g' || u === 'gr' || u === 'gram') return { kind: 'g', value: val };
    if (u === 'l' || u === 'liter') return { kind: 'ml', value: val * 1000 };
    if (u === 'cl') return { kind: 'ml', value: val * 10 };
    return { kind: 'ml', value: val };
  }

  // Kiest de best passende variant en het aantal verpakkingen voor een product.
  // - Bij gram/ml: de beschikbare variant die de benodigde hoeveelheid dekt met
  //   zo min mogelijk overschot (bij gelijke dekking: minste verpakkingen).
  // - Bij stuks: de variant die het dichtst bij de maat uit het recept ligt
  //   (bijv. "a 225 gram" kiest de 225-gramvariant), aantal = aantal stuks.
  function pickVariant(p, w) {
    // Verpakkingsgrootte staat soms in de optienaam ("ca. 1000 gram") in plaats
    // van in de variantwaarde ("met vel"): die tekst als vangnet meenemen.
    var optNames = (p.options || []).map(function (o) { return (o && o.name) || ''; }).join(' ');
    function packOf(v) {
      return parsePack((v.title || '') + ' ' + (v.name || '')) || parsePack(optNames);
    }
    var avail = [];
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) avail.push(p.variants[i]);
    }
    if (!avail.length) avail = [p.variants[0]];

    var needKind = w.g ? 'g' : (w.ml ? 'ml' : null);
    var need = w.g || w.ml || 0;

    if (needKind && need > 0) {
      var best = null;
      avail.forEach(function (v) {
        var pack = packOf(v);
        if (!pack || pack.kind !== needKind) return;
        var qty = Math.max(1, Math.ceil((need - 0.01) / pack.value));
        var total = qty * pack.value;
        if (!best || total < best.total || (total === best.total && qty < best.qty)) {
          best = { v: v, qty: qty, total: total };
        }
      });
      if (best) return best;
      // geen variant met maat: probeer de maat uit de producttitel
      var v0 = avail[0];
      var pack0 = packOf(v0) || parsePack(p.title || '');
      var qty0 = 1;
      if (pack0 && pack0.kind === needKind) qty0 = Math.max(1, Math.ceil((need - 0.01) / pack0.value));
      return { v: v0, qty: qty0 };
    }

    if (w.count) {
      var v = avail[0];
      if (w.hint) {
        var bestDiff = null;
        avail.forEach(function (cand) {
          var pack = packOf(cand);
          if (!pack || pack.kind !== 'g') return;
          var diff = Math.abs(pack.value - w.hint);
          if (bestDiff === null || diff < bestDiff) { bestDiff = diff; v = cand; }
        });
      }
      return { v: v, qty: Math.round(w.count) };
    }

    return { v: avail[0], qty: 1 };
  }

  // Product-json ophalen; als de handle verouderd is (301 op de productpagina,
  // 404 op het .js-endpoint) volgen we de redirect en proberen we de nieuwe handle.
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (r.ok) return r.json();
        return fetch('/products/' + handle, { redirect: 'follow' }).then(function (pr) {
          var m = pr.ok && pr.url ? pr.url.match(/\/products\/([a-z0-9][a-z0-9\-]*)/i) : null;
          if (!m || m[1] === handle) return null;
          return fetch('/products/' + m[1] + '.js').then(function (r2) {
            return r2.ok ? r2.json() : null;
          });
        });
      })
      .catch(function () {
        return null;
      });
  }

  function initRecipe(root) {
    var ingCard = root.querySelector('[data-recipe-ingredients]');
    var stepsCard = root.querySelector('[data-recipe-steps]');
    if (stepsCard) decorateSteps(stepsCard);
    if (!ingCard) return;

    // Eigen producten (regels met een productlink) bovenaan elke lijst
    Array.prototype.forEach.call(ingCard.querySelectorAll('ul'), function (ul) {
      var items = Array.prototype.slice.call(ul.children).filter(function (el) {
        return el.tagName === 'LI';
      });
      var withProduct = items.filter(hasProductLink);
      var without = items.filter(function (li) { return !hasProductLink(li); });
      withProduct.concat(without).forEach(function (li) { ul.appendChild(li); });
    });

    var lis = Array.prototype.slice.call(ingCard.querySelectorAll('ul li'));
    if (!lis.length) return;

    // Basis-aantal personen: uit de introtekst ("Aantal personen: 4"),
    // anders de fallback uit de sectie-instelling.
    var base = parseInt(root.getAttribute('data-base-servings'), 10) || 4;
    var intro = root.querySelector('[data-recipe-intro]');
    if (intro) {
      var m = intro.textContent.match(/Aantal personen[^0-9]{0,12}(\d+)/i);
      if (m) base = parseInt(m[1], 10);
    }
    var persons = base;

    lis.forEach(wrapQuantities);
    ingCard.classList.add('recipe-ing--enhanced');

    // Afvink-knopjes alleen bij regels met een eigen product;
    // overige ingredienten krijgen een neutraal bolletje.
    lis.forEach(function (li) {
      // Alle regelinhoud in één body-element zetten zodat de tekst als
      // doorlopende zin blijft lopen. De <li> is een flexbox; zonder deze
      // wrapper wordt elke losse <span>/<a> een eigen flex-item (een eigen
      // kolom), waardoor bijv. "uit ons assortiment" apart naast de naam komt
      // te staan en de regels rommelig en ongelijk afbreken.
      var body = document.createElement('div');
      body.className = 'recipe-ing__body';
      while (li.firstChild) {
        body.appendChild(li.firstChild);
      }
      li.appendChild(body);

      if (hasProductLink(li)) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'recipe-check';
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Product aan- of uitvinken voor de winkelwagen');
        btn.addEventListener('click', function () {
          var on = btn.getAttribute('aria-pressed') === 'true';
          btn.setAttribute('aria-pressed', String(!on));
          li.classList.toggle('is-unchecked', on);
          updateCartButton();
        });
        li.insertBefore(btn, li.firstChild);
      } else {
        var dot = document.createElement('span');
        dot.className = 'recipe-dot';
        dot.setAttribute('aria-hidden', 'true');
        li.insertBefore(dot, li.firstChild);
      }
    });

    // Personen-stepper
    var slot = root.querySelector('[data-servings-slot]');
    var valEl = null;
    if (slot) {
      slot.innerHTML =
        '<span class="recipe-servings__label">Aantal personen</span>' +
        '<span class="recipe-servings__controls">' +
        '<button type="button" class="recipe-servings__btn" data-step="-1" aria-label="Minder personen">&minus;</button>' +
        '<span class="recipe-servings__value" aria-live="polite"></span>' +
        '<button type="button" class="recipe-servings__btn" data-step="1" aria-label="Meer personen">+</button>' +
        '</span>';
      valEl = slot.querySelector('.recipe-servings__value');
      slot.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var next = persons + parseInt(b.getAttribute('data-step'), 10);
          if (next < 1 || next > 24) return;
          persons = next;
          render();
        });
      });
    }

    function render() {
      if (valEl) valEl.textContent = persons;
      root.querySelectorAll('.recipe-qty').forEach(function (sp) {
        var b = parseFloat(sp.getAttribute('data-base').replace(',', '.'));
        if (isNaN(b)) return;
        var v = (b * persons) / base;
        var rounded = Math.round(v);
        var out;
        if (Math.abs(v - rounded) < 0.05) {
          out = String(rounded);
        } else {
          out = String(Math.round(v * 10) / 10).replace('.', ',');
        }
        sp.textContent = out;
      });
    }
    render();

    // Alles-in-winkelwagen knop
    var cartBtn = root.querySelector('[data-recipe-add-all]');
    var cartError = root.querySelector('[data-cart-error]');

    // Aangevinkte producten met hun benodigde hoeveelheid (geschaald naar personen)
    function checkedProducts() {
      var map = {};
      var order = [];
      lis.forEach(function (li) {
        if (li.classList.contains('is-unchecked')) return;
        var links = li.querySelectorAll('a[href*="/products/"]');
        if (!links.length) return;
        var need = neededAmount(li);
        Array.prototype.forEach.call(links, function (a, idx) {
          var mm = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9][a-z0-9\-]*)/i);
          if (!mm) return;
          var h = mm[1];
          if (!map[h]) {
            map[h] = { handle: h, g: 0, ml: 0, count: 0 };
            order.push(h);
          }
          if (idx > 0) return; // "of"-alternatieven: geen hoeveelheid, 1 verpakking
          if (need.g) map[h].g += need.g;
          if (need.ml) map[h].ml += need.ml;
          if (need.count) map[h].count += need.count;
          if (need.hint) map[h].hint = need.hint;
        });
      });
      return order.map(function (h) {
        return map[h];
      });
    }

    function updateCartButton() {
      if (!cartBtn) return;
      var n = checkedProducts().length;
      var count = cartBtn.querySelector('[data-count]');
      if (count) count.textContent = n;
      cartBtn.disabled = n === 0;
      if (n === 0) {
        cartBtn.classList.add('recipe-cart-btn--empty');
      } else {
        cartBtn.classList.remove('recipe-cart-btn--empty');
      }
    }

    if (cartBtn) {
      if (checkedProducts().length === 0) {
        cartBtn.hidden = true;
      } else {
        updateCartButton();
        cartBtn.addEventListener('click', function () {
          addAllToCart();
        });
      }
    }

    function addAllToCart() {
      var wanted = checkedProducts();
      if (!wanted.length || cartBtn.classList.contains('is-loading')) return;
      cartBtn.classList.add('is-loading');
      if (cartError) cartError.hidden = true;
      var label = cartBtn.querySelector('.btn__text');
      var originalLabel = label ? label.innerHTML : '';
      if (label) label.textContent = 'Toevoegen…';

      Promise.all(
        wanted.map(function (w) {
          return fetchProduct(w.handle).then(function (p) {
            return { w: w, p: p };
          });
        })
      )
        .then(function (pairs) {
          var items = [];
          pairs.forEach(function (pair) {
            var p = pair.p;
            var w = pair.w;
            if (!p || !p.variants || !p.variants.length) return;
            var choice = pickVariant(p, w);
            var qty = Math.max(1, Math.min(choice.qty, 50));
            items.push({ id: choice.v.id, quantity: qty });
          });
          if (!items.length) throw new Error('geen producten');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) {
          if (!r || !r.ok) throw new Error('cart error');
          window.location.href = '/cart';
        })
        .catch(function () {
          cartBtn.classList.remove('is-loading');
          if (label) label.innerHTML = originalLabel;
          if (cartError) cartError.hidden = false;
        });
    }
  }

  // Is dit de eerste (niet-lege) tekstnode binnen het element?
  function isLeadingTextOf(el, textNode) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (!n.nodeValue.trim()) continue;
      return n === textNode;
    }
    return false;
  }

  // Vervangt getallen in een ingredient-regel door spans met data-base,
  // zodat ze geschaald kunnen worden. Getallen binnen productlinks
  // (<a>) blijven met rust: dat zijn vaak verpakkingsgroottes of namen.
  function wrapQuantities(li) {
    var walker = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      var anchor = node.parentElement && node.parentElement.closest('a');
      if (anchor) {
        // Getal in een productlink: alleen een hoeveelheid die de linktekst
        // opent ("1 kg Schotse runder riblap") schalen, de rest met rust laten.
        if (!isLeadingTextOf(anchor, node) || !/^\s*\d/.test(node.nodeValue)) continue;
        node.fteLeadingOnly = true;
      }
      if (QTY_RE.test(node.nodeValue)) nodes.push(node);
      QTY_RE.lastIndex = 0;
    }
    nodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      var frag = document.createDocumentFragment();
      var lastIndex = 0;
      var leadingOnly = !!textNode.fteLeadingOnly;
      var done = false;
      text.replace(QTY_RE, function (match, offset) {
        if (leadingOnly && (done || text.slice(0, offset).trim() !== '')) return match;
        done = true;
        frag.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
        var sp = document.createElement('span');
        sp.className = 'recipe-qty';
        sp.setAttribute('data-base', match.replace(',', '.'));
        sp.textContent = match;
        frag.appendChild(sp);
        lastIndex = offset + match.length;
        return match;
      });
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  // Zet "1. Stapnaam" / "Stap 1: Stapnaam" paragrafen en (sub)koppen om
  // naar een stap met nummer-cirkel.
  function decorateSteps(card) {
    card.querySelectorAll('p, h3, h4, h5').forEach(function (p) {
      var m = p.textContent.match(/^\s*(?:Stap\s+)?(\d+)\s*[:.)]\s*/i);
      if (!m) return;
      // Verwijder het voorloopnummer uit de eerste tekstnode(s)
      var toRemove = m[0].length;
      var walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null);
      var node;
      while (toRemove > 0 && (node = walker.nextNode())) {
        var take = Math.min(toRemove, node.nodeValue.length);
        node.nodeValue = node.nodeValue.slice(take);
        toRemove -= take;
      }
      var num = document.createElement('span');
      num.className = 'recipe-step__num';
      num.setAttribute('aria-hidden', 'true');
      num.textContent = m[1];
      p.classList.add('recipe-step');
      p.insertBefore(num, p.firstChild);
    });
  }

  function boot() {
    document.querySelectorAll('[data-recipe-root]').forEach(initRecipe);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
